import { MDSMenu } from "@/mds/menu";
import { MDSButton } from "@/mds/components/buttons/button";
import styled from "@emotion/styled";
import { Popover } from "react-aria-components";

export const SplitButtonWrapper = styled.div`
  display: inline-flex;
  align-items: stretch;
`;

interface StyledPopoverProps {
  width?: number;
}
export const StyledPopover = styled(Popover)<StyledPopoverProps>(({ width }) => ({
  width: width,
  minWidth: width,
}));

export const ButtonWrapper = styled.div`
  display: inline-flex;
  flex: 1;
`;

// this is a new style of menu that we're only using here right now.
export const StyledNewMenu = styled(MDSMenu)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
  border: ${({ theme }) => `1px solid ${theme.colors.grey.x25}`};
  box-shadow:
    0px 4px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: ${({ theme }) => theme.spacing.xs};
  max-height: inherit;
  box-sizing: border-box;
  overflow: auto;
  outline: none;
`;

export const LeftButton = styled(MDSButton)`
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm};
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.smd};
  flex: 1;
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.grey.x25};
  }
`;

export const RightButton = styled(MDSButton)`
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm};
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.smd};
  flex: 1;
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.grey.x25};
  }
`;

export const SoloButton = styled(MDSButton)`
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm};
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.smd};
  flex: 1;
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.grey.x25};
  }
`;

export const SoloIconButton = styled(MDSButton)`
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm};
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.sm};
  flex: 1;
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.grey.x25};
  }
`;

export const TopButton = styled(MDSButton)`
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: none;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm};
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.sm};
  flex: 1;
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.grey.x25};
  }
`;

export const BottomButton = styled(MDSButton)`
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: none;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm};
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.sm};
  flex: 1;
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.grey.x25};
  }
`;

export const MenuButton = styled(MDSButton)`
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.smd};
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.grey.x25};
  }
`;
